// extracted by mini-css-extract-plugin
export default {"menu":"CreateFileAndFolderActions_menu__fd47K","button":"CreateFileAndFolderActions_button__NydHL","hidden":"CreateFileAndFolderActions_hidden__Ou8kz"};